var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserAvatorIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "person",
    d: "M56.889,33.018a3.339,3.339,0,0,0-4.795-.006,3.308,3.308,0,0,0-.84,2.524A3.559,3.559,0,0,0,54.494,39a3.56,3.56,0,0,0,3.24-3.463A3.3,3.3,0,0,0,56.889,33.018ZM59.994,46h-11a.969.969,0,0,1-.756-.348,1.1,1.1,0,0,1-.224-.91,5.35,5.35,0,0,1,2.381-3.555,7.672,7.672,0,0,1,8.2,0,5.349,5.349,0,0,1,2.381,3.555,1.1,1.1,0,0,1-.224.91.969.969,0,0,1-.756.348Z",
    transform: "translate(-47.994 -32)",
    fill: "#a5a7a7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserAvatorIcon);
export default __webpack_public_path__ + "static/media/user-avator-icon.d22b46177c1d81492e6bd7164e9e8a39.svg";
export { ForwardRef as ReactComponent };